import { createI18n } from "vue-i18n";

import en from "./locales/en.json";
import es from "./locales/es.json";
import ar from "./locales/ar.json";
import fr from "./locales/fr.json";
import it from "./locales/it.json";
import lv from "./locales/lv.json";
import pt from "./locales/pt.json";
import ru from "./locales/ru.json";
import sr from "./locales/sr.json";
import zh from "./locales/zh.json";
import pt_BR from "./locales/pt-br.json";

const i18n = createI18n({
  legacy: false,
  locale: (window.app?.locale || "en"),
  fallbackLocale: "en",
  messages: {
    en,
    es,
    ar,
    fr,
    it,
    lv,
    ru,
    sr,
    zh,
    pt,
    'pt-br': pt_BR,
  },
});

export default i18n;
